<div>
  <div class="nav-item" (click)="onBookNowClick()">
    <span class="d-flex align-items-center icon-gap">
      <div class="fa-kit fa-book"></div>
      <div>{{ headerCopy.book.name }}</div>
    </span>
  </div>
  <div
    [routerLink]="headerCopy.manageTrip.link"
    class="nav-item"
  >
    <span class="d-flex align-items-center icon-gap">
      <div class="fa-kit fa-your-trips"></div>
      <div>{{ headerCopy.manageTrip.name }}</div>
    </span>
  </div>
  <div
    [routerLink]="headerCopy.destinations.link"
    class="nav-item"
  >
    <span class="d-flex align-items-center icon-gap">
      <i class="fa-kit fa-check-in"></i>
      {{ headerCopy.destinations.name }}
    </span>
  </div>
  <div [routerLink]="headerCopy.support.link" class="nav-item">
    <span class="d-flex align-items-center icon-gap">
      <div class="fa-kit fa-support"></div>
      <div>{{ headerCopy.support.name }}</div>
    </span>
  </div>
  <accordion [isAnimated]="true">
    <accordion-group
      [isOpen]="openedTravelInfoGroup"
      (isOpenChange)="setOpenedTravelInfoGroup($event)"
      class="menu-accordion"
    >
      <div
        accordion-heading
        class="toggle-container flex-toggle-container"
        [ngClass]="{ collapsed: !openedTravelInfoGroup }"
        [attr.aria-expanded]="openedTravelInfoGroup"
      >
        <span class="d-flex align-items-center icon-gap">
          <div class="fa-solid fa-info-circle"></div>
          <div>
            {{ headerCopy.travelInfo }}
          </div>
        </span>
        <i class="toggle-chevron"></i>
      </div>
      <div>
        <div
          class="nav-accordion-item"
          (click)="goTo(headerCopy.travelInfo1.link)"
        >
          <span>{{ headerCopy.travelInfo1.name }}</span>
        </div>
        <div
          class="nav-accordion-item"
          (click)="goTo(headerCopy.travelInfo2.link)"
        >
          <span>{{ headerCopy.travelInfo2.name }}</span>
        </div>
        <div
          class="nav-accordion-item"
          (click)="goTo(headerCopy.travelInfo3.link)"
        >
          <span>{{ headerCopy.travelInfo3.name }}</span>
        </div>
        <div
          class="nav-accordion-item"
          (click)="goTo(headerCopy.travelInfo4.link)"
        >
          <span>{{ headerCopy.travelInfo4.name }}</span>
        </div>
        <div
          class="nav-accordion-item"
          (click)="goTo(headerCopy.travelInfo5.link)"
        >
          <span>{{ headerCopy.travelInfo5.name }}</span>
        </div>
        <div
          class="nav-accordion-item"
          (click)="goTo(headerCopy.travelInfo6.link)"
        >
          <span>{{ headerCopy.travelInfo6.name }}</span>
        </div>
        <div
          class="nav-accordion-item"
          (click)="goTo(headerCopy.travelInfo7.link)"
        >
          <span>{{ headerCopy.travelInfo7.name }}</span>
        </div>
      </div>
    </accordion-group>
  </accordion>
</div>